//Make sure controller & component names are different from portal's!
(function (ng, app) {
    app.config([
        '$stateProvider',
        function ($stateProvider) {
            $stateProvider.state('Portal.FigPlatform',
                {
                    url: '/FigPlatform',
                    component: 'figPlatformComponent',
                    resolve: {}
                });
        }
    ]);

    app.component('figPlatformComponent', {
        templateUrl: 'App.Portal/States/FigPlatform/FigPlatform.template.html',
        controller: 'FigPlatformController',
        bindings: {
            user: "<"
        }
    });

    app.controller('FigPlatformController', FigPlatformController);

    FigPlatformController.$inject = ['_', 'figPlatformFactory', '$filter', '$mdSidenav', '$q', '$state', '$window'];

    function FigPlatformController(_, figPlatformFactory, $filter, $mdSidenav, $q, $state, $window) {
        var $ctrl = this;

        ng.extend($ctrl, {
            ui: {
                loadingCat: false,
                loadingTile: false,
            },
            searchText: '',
            showFilteredList: false,
        });

        $ctrl.applyFilters = function () {
            $ctrl.showFilteredList = $ctrl.searchText.length > 0 ? true : false;
            var result = ng.copy($ctrl.tiles);
            result = $filter('filter')(result, $ctrl.searchText);
            //result = $filter('filter')(result, $ctrl.filterTilesFn);
            $ctrl.filteredList = result;
        };

        $ctrl.clearSearch = function () {
            $ctrl.searchText = '';
            $ctrl.showFilteredList = false;
        };

        $ctrl.orderAsc = function (arr) {
            return $filter('min')($filter('map')(arr, 'CategoryOrder[0]'));
        }

        $ctrl.$onInit = function () {
            $ctrl.ui.loadingCat = true;
            $ctrl.ui.loadingTile = true;
            figPlatformFactory.getAllCategories()
                .then(function (response) {
                    $ctrl.categories = response;
                })
                .finally(function () {
                    $ctrl.ui.loadingCat = false;
                });
            figPlatformFactory.getUserPermittedTiles()
                .then(function (response) {
                    $ctrl.tiles = response;
                })
                .finally(function () {
                    $ctrl.ui.loadingTile = false;
                });
        };
    }
})(window.angular, window.app);